import React from "react"
import styled from "styled-components"
import { useTheme } from "styled-components"

const TRACK_WIDTH = 44
const TRACK_HEIGHT = 26
const THUMB_SIZE = 22
const THUMB_GAP = 2

const SwitchButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`

const Track = styled.span<{ $on: boolean; $onColor: string; $offColor: string }>`
  position: relative;
  display: inline-block;
  width: ${TRACK_WIDTH}px;
  height: ${TRACK_HEIGHT}px;
  border-radius: ${TRACK_HEIGHT / 2}px;
  background-color: ${({ $on, $onColor, $offColor }) => ($on ? $onColor : $offColor)};
  transition: background-color 0.2s ease;
`

const Thumb = styled.span<{ $on: boolean }>`
  position: absolute;
  top: ${THUMB_GAP}px;
  left: ${({ $on }) =>
    $on ? `${TRACK_WIDTH - THUMB_SIZE - THUMB_GAP}px` : `${THUMB_GAP}px`};
  width: ${THUMB_SIZE}px;
  height: ${THUMB_SIZE}px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
  transition: left 0.2s ease;
`

export type WebSwitchProps = {
  value?: boolean
  onValueChange?: (value: boolean) => void
  disabled?: boolean
  testID?: string
}

/** H5 开关：绿色主题，兼容 RN Switch 的 value / onValueChange API */
export function WebSwitch({ value, onValueChange, disabled, testID }: WebSwitchProps) {
  const theme = useTheme()
  const on = !!value

  return (
    <SwitchButton
      type="button"
      role="switch"
      aria-checked={on}
      disabled={disabled}
      data-testid={testID}
      onClick={() => {
        if (!disabled) onValueChange?.(!on)
      }}
    >
      <Track
        $on={on}
        $onColor={theme.colors.primary}
        $offColor={theme.colors.border}
      >
        <Thumb $on={on} />
      </Track>
    </SwitchButton>
  )
}
